import React from "react";
import "./BrokerHeader.css";
import StockYaariLogo from "../../assets/images/stockyaariLogo.png";
import link from "../../assets/images/Link.png";
import { useLocation } from "react-router-dom";

const BrokerHeader = () => {
  const { state } = useLocation();
  const broker = state?.broker;

  return (
    <div className="broker-header-logo-section">
      {/* StockYaari Logo */}
      <div className="broker-header-stockyaari-logo">
        <img src={StockYaariLogo} alt="StockYaari Logo" />
      </div>

      {/* Chain/Link Icon */}
      <div className="broker-header-link-icon-wrapper">
        <img src={link} alt="Link Icon" />
      </div>

      {/* Broker Logo */}
      <div className="broker-header-broker-logo">
        <img
          src={broker?.logo}
          alt={`${broker?.displayName} Logo`}
          width={140}
          height={48}
        />
      </div>
    </div>
  );
};

export default BrokerHeader;
